// extracted by mini-css-extract-plugin
module.exports = {"reviewButtonContainer":"AddCardModal_reviewButtonContainer__24QmP","container":"AddCardModal_container__3en6M"};